export default __webpack_public_path__ + "static/media/treat-yourself-1920w.f515c8db.webp";